var map = {
	"./bg-exclusive.webp": 1319,
	"./border-bg-sm.png": 1320,
	"./border-bg-xm.png": 1321,
	"./border-bg.png": 1322,
	"./btn-active.png": 1323,
	"./casino-hover.webp": 1324,
	"./cny-flower-1.webp": 1325,
	"./cny-flower-2.webp": 1326,
	"./cny-mobile-bg.webp": 1327,
	"./content-deco-1.webp": 1328,
	"./content-deco-2.webp": 1329,
	"./content-deco-3.webp": 1330,
	"./content-deco-4.webp": 1331,
	"./content-deco-5.webp": 1332,
	"./deposit-icon.webp": 1333,
	"./event-border-hover.webp": 1334,
	"./games-hover.webp": 1335,
	"./home-icon-active.webp": 1336,
	"./home-icon.webp": 1337,
	"./live-icon-active.webp": 1338,
	"./live-icon.webp": 1339,
	"./lottery-hover.webp": 1340,
	"./master-bg.png": 1341,
	"./me-icon-active.webp": 1342,
	"./me-icon.webp": 1343,
	"./p2p-hover.webp": 1344,
	"./platform.webp": 1345,
	"./product-overview-bg.webp": 1346,
	"./promos-icon-active.webp": 1347,
	"./promos-icon.webp": 1348,
	"./slots-hover.webp": 1349,
	"./sponsor-icon-active.webp": 1350,
	"./sponsor-icon.webp": 1351,
	"./sports-hover.webp": 1352,
	"./title-deco-bg.webp": 1353,
	"./title-deco-left.webp": 1354,
	"./title-deco-right.webp": 1355,
	"./vip-icon-active.webp": 1356,
	"./vip-icon.webp": 1357,
	"./withdraw-icon.webp": 1358,
	"./wwr-bg.webp": 1359,
	"./wwr-img.webp": 1360
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 147;